<template>
	<div id="questionnaireBox">
		<div class="layout-content">
			<div class="layout-container">
				<div class="layout-content-title">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item>
							<h2>调查问卷</h2>
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="creatAndFind">
					<!-- <search-box v-model="searchText" @on-search="search" /> -->

					<el-button class="creatBtn" type="primary" @click="goCreatQuestionnaire">
						<svg class="iconpark-icon"><use href="#tianjia"></use></svg>
						创建
					</el-button>
				</div>
				<el-tabs :value="tabName" @tab-click="tabClick">
					<el-tab-pane label="调查问卷" name="0">
						<el-row :gutter="16">
							<questionnaire-item
								v-for="item in questionnaireAndVoteList"
								:key="item.id"
								:list-item="item"
								:page-num="pageNum"
								:now-tab-type="nowTabType"
								:total="total"
								:page-size="pageSize"
								:questionnaire-and-vote-list="questionnaireAndVoteList"
								@childMethod="getQuestionnaireAndVote"
							/>
							<div v-if="total <= 0 && !showNoResult" class="noQuestionnaire">
								<svg class="icon icon3" aria-hidden="true">
									<use xlink:href="#icon-wenjuankongzhuangtai" />
								</svg>
								<p>暂无调查问卷</p>
							</div>
							<div v-if="total <= 0 && showNoResult" class="noQuestionnaire">
								<svg class="icon icon3" aria-hidden="true">
									<use xlink:href="#icon-wenjuankongzhuangtai" />
								</svg>
								<p>没有找到符合条件的结果</p>
							</div>
						</el-row>
					</el-tab-pane>
					<!-- <el-tab-pane label="投票" name="1">
						<el-row :gutter="16">
							<questionnaire-item
								v-for="item in questionnaireAndVoteList"
								:key="item.id"
								:list-item="item"
								:page-num="pageNum"
								:total="total"
								:page-size="pageSize"
								:now-tab-type="nowTabType"
								:questionnaire-and-vote-list="questionnaireAndVoteList"
								@childMethod="getQuestionnaireAndVote"
							/>
							<div v-if="total <= 0 && !showNoResult" class="noQuestionnaire">
								<svg class="icon icon3" aria-hidden="true">
									<use xlink:href="#icon-toupiaokongzhuangtai" />
								</svg>
								<p>暂无投票</p>
							</div>
							<div v-if="total <= 0 && showNoResult" class="noQuestionnaire">
								<svg class="icon icon3" aria-hidden="true">
									<use xlink:href="#icon-toupiaokongzhuangtai" />
								</svg>
								<p>没有找到符合条件的结果</p>
							</div>
						</el-row>
					</el-tab-pane> -->
				</el-tabs>
				<el-pagination
					v-if="!(total <= 0)"
					:page-size="pageSize"
					:total="total"
					layout="prev, pager, next"
					@current-change="getQuestionnaireAndVote"
				/>
			</div>
		</div>
		<el-dialog :visible.sync="creatDialogVisible" :center="true" title="新建" width="520px" class="creatDialog">
			<div class="createContainer">
				<div class="createItem" @click="goCreatQuestionnaire">
					<img src="@/assets/img/wenjuan.png" alt="" />
					<span>创建问卷</span>
				</div>
				<div class="createItem" @click="goCreatVote">
					<img src="@/assets/img/vote.png" alt="" />
					<span>创建投票</span>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import questionnaireItem from '@/components/questionnaireItem.vue';
import { survey } from '@/services';
// import searchBox from '@/components/searchBox.vue';
export default {
	components: {
		questionnaireItem,
		// searchBox,
	},
	data() {
		return {
			creatDialogVisible: false,
			nowTabType: 0, //当前标签页
			total: 0,
			pageNum: 1,
			pageSize: 12,
			questionnaireAndVoteList: [], //列表信息
			searchText: '',
			tabName: '0',
			showNoResult: false,
			// currentPage:1,//当前页
		};
	},
	watch: {},
	created() {
		if (this.$route.params.type) {
			const type = this.$route.params.type;
			this.tabName = type + '';
			this.nowTabType = type;
		} else if (parseInt(this.$route.query.type) === 1) {
			const type = this.$route.query.type;
			this.tabName = type + '';
			this.nowTabType = type;
		}

		this.getQuestionnaireAndVote();
	},
	methods: {
		//获取列表信息
		getQuestionnaireAndVote(val) {
			if (val) {
				this.pageNum = val;
			}
			const params = {
				type: this.nowTabType,
				pageNum: this.pageNum,
				pageSize: this.pageSize,
			};
			survey.getQuestionnaireAndVote(params).then(({ data, ok }) => {
				if (ok) {
					this.questionnaireAndVoteList = data.data.records;
					this.total = data.data.total;
				} else {
					this.$message.error(data.msg);
				}
			});
			this.showNoResult = false;
		},

		//创建问卷跳转
		goCreatQuestionnaire() {
			this.creatDialogVisible = false;
			this.$router.push({
				// name: 'setQuestionnaire',
				// params: { handle: 'create', type: 0 },
				path: '/setQuestionnaire/noId/create/0',
			});
		},
		//创建投票跳转
		goCreatVote() {
			this.creatDialogVisible = false;
			this.$router.push({
				// name: 'setQuestionnaire',
				// params: { handle: 'create', type: 1 },
				path: '/setQuestionnaire/noId/create/1',
			});
		},
		//标签页点击事件
		tabClick(val) {
			// console.log(1111)
			this.nowTabType = val.label === '调查问卷' ? 0 : 1;
			// console.log(this.nowTabType)
			this.getQuestionnaireAndVote(1);
		},
		//查询
		search() {
			// console.log(this.searchText)
			const data = {
				type: this.nowTabType,
				pageNum: this.pageNum,
				searchText: this.searchText,
			};
			survey.getQuestionnaireAndVote(data).then(({ ok, data }) => {
				if (ok) {
					this.questionnaireAndVoteList = data.data.records;
					this.total = data.data.total;
					if (data.data.total == 0) {
						this.showNoResult = true;
					}
				} else {
					this.$message.error(data.msg);
				}
			});
		},
	},
};
</script>
<style lang="less">
#questionnaireBox {
	padding: 0 0 30px 0;
	min-height: 100%;
	background: rgba(242, 243, 245, 1);
	.layout-content {
		overflow: hidden;
		.layout-container {
			position: relative;
			.layout-content-title {
				font-size: 14px;
				position: absolute;
				z-index: 10;
				left: 130px;
				top: 18px;
				.el-breadcrumb {
					h2 {
						font-size: 20px;
						line-height: 28px;
						color: #2b313c;
					}
				}
			}
			.creatAndFind {
				position: absolute;
				top: 16px;
				right: 130px;
				display: flex;
				justify-content: flex-end;
				z-index: 999;
				.creatBtn {
					font-size: 14px;
					line-height: 22px;
					background: rgba(52, 145, 250, 1);
					span {
						display: flex;
						align-items: center;
						justify-content: center;
					}
					.iconpark-icon {
						font-size: 16px;
						margin-right: 4px;
						fill: #fff;
					}
				}
				.el-button {
					width: 80px;
					height: 32px;
					padding: 0;
					line-height: 32px;
					border-radius: 2px;
				}
				.icon {
					width: 1em;
					height: 1em;
					vertical-align: -0.15em;
					fill: currentColor;
					overflow: hidden;
					&.icon1 {
						width: 20px;
						height: 20px;
						color: #606266;
						margin-top: 14px;
						margin-right: 20px;
						cursor: pointer;
					}
					&.icon2 {
						width: 16px;
						height: 16px;
					}
				}
			}
			.el-tabs {
				.el-tabs__header {
					background-color: #fff;
					padding-left: 310px;
					margin: 0;
					height: 64px;
					.el-tabs__nav-wrap {
						display: none;
					}
				}
				.el-tabs__nav-wrap::after {
					display: none;
				}
				.el-tabs__nav {
					.el-tabs__item {
						border: none;
						outline: 0;
						height: 64px;
						line-height: 64px;
					}
					.el-tabs__item.is-active {
						color: #4d8ef9;
					}
				}
				.el-tabs__content {
					padding: 24px 130px 30px;
					background: rgba(242, 243, 245, 1);
				}
				.el-tab-pane {
					.el-row {
						// width: 100%;
					}
				}
				.el-tabs__active-bar {
				}
				.noQuestionnaire {
					text-align: center;
					min-height: 600px;
					.icon3 {
						width: 135px;
						height: 135px;
						color: #606266;
						margin-top: 200px;
					}
					p {
						margin: 0;
						color: #b8bcc4;
					}
				}
			}
		}
	}
	.creatDialog {
		.el-dialog {
			box-sizing: border-box;
			.el-dialog__header {
				padding: 20px;
				text-align: center;
				border-bottom: 1px solid #d9d9d9;
				span {
					font-size: 16px;
				}
			}
			.el-dialog__body {
				padding: 40px 66px 52px;
			}
			.createContainer {
				display: flex;
				justify-content: space-between;
				.createItem {
					display: flex;
					flex-direction: column;
					align-items: center;
					cursor: pointer;
					img {
						width: 160px;
						height: 160px;
					}
					span {
						margin-top: 12px;
						color: rgba(78, 89, 105, 1);
						font-size: 14px;
						line-height: 22px;
					}
				}
			}
			.el-dialog__footer {
			}
		}
	}
}
@media screen and (max-width: 1600px) {
	#questionnaire {
		.layout-content {
			.layout-container {
				.layout-content-title {
					left: 40px;
				}
				.creatAndFind {
					right: 40px;
				}
				.el-tabs {
					.el-tabs__header {
						padding-left: 220px;
					}
					.el-tabs__content {
						padding: 24px 40px 30px;
					}
				}
			}
		}
	}
}
</style>
